import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 840 230",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		transform: "translate(40 44) scale(2.95)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#ff5c8a",
			d: "M24.14 0.55 L49.92 0.55 Q73.56 0.55 59.11 19.25 L42.28 41.02 Q37.03 47.83 31.78 41.02 L14.95 19.25 Q0.5 0.55 24.14 0.55 Z"
		})
	}), /* @__PURE__ */ _jsx("text", {
		x: 272,
		y: 188,
		fill: "currentColor",
		fontFamily: "'Montserrat', sans-serif",
		fontSize: 210,
		fontWeight: 500,
		letterSpacing: -4,
		children: "tasks"
	})]
});
export default SvgLogo;
